import { Outlet } from "@tanstack/react-router";
import { PreloginLayout } from "@/layouts/PreloginLayout";

/** Guest route shell (login / forgot / set password). */
function GuestLayout() {
  return (
    <PreloginLayout>
      <Outlet />
    </PreloginLayout>
  );
}

export default GuestLayout;
